import LDClient from "launchdarkly-js-client-sdk";
import type { LDClientBase } from "launchdarkly-js-sdk-common";

export type LaunchDarklyInitOptions = {
  context: {
    key: string;
    licence: string;
    country: string;
    language: string;
    [key: string]: string;
  };
  onChange?: () => void;
  onReady?: () => void;
  timeout?: number;
};

export const initLaunchDarkly = async ({
  context,
  onChange,
  onReady,
  timeout,
}: LaunchDarklyInitOptions): Promise<LDClientBase> => {
  // LaunchDarkly Client-side ID
  const clientSideID = import.meta.env.VITE_LAUNCH_DARKLY_SDK_KEY;

  if (!clientSideID) {
    throw new Error("LaunchDarkly SDK key is not set");
  }

  const ldclient = LDClient.initialize(clientSideID, {
    kind: "user",
    ...context,
  });

  ldclient.on("ready", () => {
    onReady?.();
  });
  ldclient.on("change", () => {
    onChange?.();
  });

  await ldclient.waitForInitialization(timeout);

  return ldclient;
};
